import { render } from "./DesktopGroupTable.vue?vue&type=template&id=5846d5d2&scoped=true"
import script from "./DesktopGroupTable.vue?vue&type=script&lang=js"
export * from "./DesktopGroupTable.vue?vue&type=script&lang=js"

import "./DesktopGroupTable.vue?vue&type=style&index=0&id=5846d5d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5846d5d2"

export default script